<div class="ss-view-toggle" [class.ss-view-toggle--labeled]="variant === 'labeled'" [attr.role]="variant === 'labeled' ? 'radiogroup' : 'group'" [attr.aria-label]="label">
  <ng-container *ngFor="let option of options">
    <button
      *ngIf="variant === 'icon'"
      type="button"
      [attr.aria-pressed]="value === option.value"
      [attr.aria-label]="option.label"
      [ssTooltip]="option.label"
      [disabled]="disabled || option.disabled"
      (click)="select(option)">
      <lucide-icon [name]="option.icon" [size]="16" aria-hidden="true"></lucide-icon>
    </button>

    <button
      *ngIf="variant === 'labeled'"
      type="button"
      role="radio"
      [attr.aria-checked]="value === option.value"
      [disabled]="disabled || option.disabled"
      (click)="select(option)">
      <lucide-icon [name]="option.icon" [size]="15" aria-hidden="true"></lucide-icon>
      {{ option.label }}
    </button>
  </ng-container>
</div>
